export function resolveCrmxV2KitEnabled(
  defaultEnabled: boolean,
  runtimeOverrideEnabled: boolean,
  search: string,
): boolean {
  if (!runtimeOverrideEnabled) return defaultEnabled;

  const override = new URLSearchParams(search).get("v2kit");
  if (override === "1") return true;
  if (override === "0") return false;
  return defaultEnabled;
}

export function resolveCrmxSettingsEnabled(
  defaultEnabled: boolean,
  runtimeOverrideEnabled: boolean,
  search: string,
): boolean {
  if (!runtimeOverrideEnabled) return defaultEnabled;
  const override = new URLSearchParams(search).get("settings");
  if (override === "1") return true;
  if (override === "0") return false;
  return defaultEnabled;
}
